import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';

import BackendService from '../services/backendService/backendService';
import {
  clearHasStartedDetectingStrengths,
  hasStartedDetectingStrengths,
  setHasStartedDetectingStrengths,
} from '../utils/liveGameStateStorage';

const useDetectStrengths = ({ gameId, slideId }: { gameId: string; slideId: string }) => {
  const queryClient = useQueryClient();
  const { mutate: detectStrengths, isPending: isDetecting } = useMutation({
    mutationKey: ['detectStrengths', gameId, slideId],
    mutationFn: async () => {
      if (hasStartedDetectingStrengths(gameId, slideId)) return;
      setHasStartedDetectingStrengths(gameId, slideId);
      await BackendService.instance.game.detectStrengths({
        slideId,
        livePresentationId: gameId,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['game-leaderboard'] });
      queryClient.invalidateQueries({
        // this cackekey has slideId, gameId which is why it is 2nd and then 1st
        queryKey: ['responses', slideId, gameId],
      });
    },
    onError: () => {
      // Allow retries if the detect request fails.
      clearHasStartedDetectingStrengths(gameId, slideId);
    },
  });

  const hasStarted = useMemo(() => hasStartedDetectingStrengths(gameId, slideId), [
    gameId,
    slideId,
  ]);

  return { detectStrengths, isDetecting, hasStarted };
};

export default useDetectStrengths;
